import { Shoppingcart } from './Shoppingcart';

class ShoppingcartIndex {
    init() {
        this.shoppingcart = new Shoppingcart();

        let items = document.querySelectorAll('.shopping-cart-item');

        if (items) {
            items.forEach(item => {
                item.addEventListener('click', Event => {
                    document.dispatchEvent(new CustomEvent('GTMSelectItem',  {
                        detail: {
                            itemElement: item,
                            itemId: item.querySelector('.info-block p') ? item.querySelector('.info-block p').innerText.trim() : '',
                            itemName: item.querySelector('.info-block a') ? item.querySelector('.info-block a').innerText.trim() : '',
                            colorElements: item.querySelectorAll('.style_row'),
                            itemPrice: item.querySelector('.price-block--price') ? item.querySelector('.price-block--price').innerText : '',
                        }
                    }));
                });
            });
        }

        this.actions();
    }

    actions() {
        this.shoppingcart.actions();
    }
}

addEventListener('DOMContentLoaded', e => {
    const shoppingcartIndex = new ShoppingcartIndex();

    shoppingcartIndex.init();
});
